let attempts = 0
let backoff = false
let timers = { retry: null, backoff: null }

export default {
  reset: function () {
    if (timers.retry) {
      clearTimeout(timers.retry)
    }

    if (timers.backoff) {
      clearTimeout(timers.backoff)
    }

    attempts = 0
    backoff = false
    timers = { retry: null, backoff: null }
  },
  run: function (baseDelay, delayFunc, callback) {
    if (backoff) {
      if (timers.retry) {
        clearTimeout(timers.retry)
      }

      timers.retry = setTimeout(() => { this.run(baseDelay, delayFunc, callback) }, baseDelay)
    } else {
      attempts++

      callback()

      backoff = true
      const delay = delayFunc(baseDelay, attempts)

      if (timers.backoff) {
        clearTimeout(timers.backoff)
      }

      timers.backoff = setTimeout(() => {
        backoff = false
      }, delay)
    }
  },
  exponentialDelay: function (baseDelay, attempts) {
    return Math.pow(2, attempts - 1) * baseDelay
  },
  exponential: function (baseDelay, callback) {
    return this.run(baseDelay, this.exponentialDelay, callback)
  },
  linearDelay: function (baseDelay, attempts) {
    return attempts * baseDelay
  },
  linear: function (baseDelay, callback) {
    return this.run(baseDelay, this.linearDelay, callback)
  }
}
